import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import useSWR from 'swr';

import { mergeClasses } from '@utils';

const fetcher = url => fetch(url).then(r => r.json());

export default function Questions({ isPopular }) {
  const history = useHistory();
  const { category, question } = useParams();

  const searchParams = useMemo(() => {
    const params = new URLSearchParams();
    if (isPopular) {
      params.append('super_popular', 'true');
    }
    if (category) {
      params.append('category__url_name', category);
    }
    return params;
  }, [isPopular, category]);

  const { data: questionsData, isLoading: isLoadingQuestions } = useSWR(
    `/api/faq/questions/?${searchParams.toString()}`,
    fetcher
  );

  const handleHistoryPush = useCallback(
    (event, url) => {
      event.preventDefault();
      history.push(url);
    },
    [history]
  );

  if (isLoadingQuestions)
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className="h-12 w-12 animate-spin fill-black"
      >
        <path d="M12 3C16.9706 3 21 7.02944 21 12H19C19 8.13401 15.866 5 12 5V3Z" />
      </svg>
    );

  return (
    <ul className="list-none space-y-4">
      {questionsData?.data?.map?.(({ id, attributes }) => {
        const {
          text,
          url_name: questionSlug,
          category: { url_name: categorySlug }
        } = attributes || {};
        const isMatch = question === questionSlug;

        return (
          <li key={id} className="py-2">
            <a
              href={`/faq/${categorySlug}/${questionSlug}/`}
              onClick={event =>
                handleHistoryPush(event, `/${categorySlug}/${questionSlug}/`)
              }
              className={mergeClasses(
                'block py-2 font-bold text-black no-underline',
                {
                  'pointer-events-none before:mr-4 before:w-auto before:text-dark-gray before:content-["—"]':
                    isMatch
                }
              )}
            >
              {text}
            </a>
          </li>
        );
      })}
    </ul>
  );
}

Questions.propTypes = {
  isPopular: PropTypes.bool
};

Questions.defaultProps = {
  isPopular: false
};
